import { Component, Inject, OnInit, ElementRef, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, NgForm, Validators, FormControl } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectService } from 'src/app/_services/project.service';
import { DOCUMENT } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { environment } from '../../../environments/environment';
import { ExcelService } from 'src/app/_services/excel.service';
// import { MatMenuTrigger } from '@angular/material';
import { Subscription } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';
import { DataService } from 'src/app/_services/data.service';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-manage-test-data',
  templateUrl: './manage-test-data.component.html',
  styleUrls: ['./manage-test-data.component.scss']
})
export class ManageTestDataComponent implements OnInit {
  testDataForm: UntypedFormGroup;
  addHeaderForm: UntypedFormGroup;
  testDataUpdateForm: UntypedFormGroup;
  projectName: any;
  submitted = false;
  url: string;
  title: any;
  projectId: string;
  testData: any;
  projectData: any;
  scriptDataById: any;
  updateForm: boolean = false;
  executionMode = ["SEQUENTIAL", "PARALLEL"]
  Sequential = 'SEQUENTIAL';
  default = 'default';
  public searchString: string;
  testDataFileName: string;
  testDataFile;
  selectedTestDataId: string;
  selectedTestDataName: string;
  testDataSourceName : string = '';
  testCaseId;
  testId = undefined;
  gridTableHeader = [];
  gridTableBody = [];
  emptyGridTableHeader = [];
  emptyGridTableBody = [];
  selectedHeader : string = "";
  selectedHeaderIndex;
  showHeaderFormMsg : boolean = false;
  enableTableEdit : boolean = false;
  selectedGridValue : string = '';
  selectedRow : string = "";
  selectedIndex : string = "";
  selectedMatIndex : number = 0;
  showBackButton : boolean = false;
  contextMenuPosition = { x:'0px', y:'0px' };
  subscription: Subscription;
 
  @ViewChild(MatMenuTrigger,null) contextMenu: MatMenuTrigger;
  @ViewChild('cancelImportTestDataScreen', null) cancelImportTestDataScreen: ElementRef;
  @ViewChild('cancelHeaderUpdateModel', null) cancelHeaderUpdateModel: ElementRef;
  @ViewChild('cancelAddHeaderModel', null) cancelAddHeaderModel: ElementRef;
  settingNameForHightLight: any;
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'Manage Test Data',
    data: undefined,
  }
  currentUrl: any;
  previousUrl: any=[];
  previousUrltemp: any;
  agentCheck: boolean;
  


  constructor(
    private dataService: DataService,
    private formBuilder: UntypedFormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router : Router,
    private project: ProjectService,
    private toastrService: ToastrService,
    private confirmationDialogService: ConfirmationDialogService,
    private excelService: ExcelService,
    private urlService: UrlService,
    private memoryService: MemoryService,
    private homeService: HomeService,
    @Inject(DOCUMENT) private document: Document,) {
    this.url = environment.baseUrl
  }

  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res)=>
    {
      this.agentCheck = res;
    })
    this.subscription = this.project.getTestData().subscribe((res)=> 
    {
        this.getProjectDetails();
    })
    setTimeout(()=>
    {
      this.getProjectDetails();
    },0)
    this.loadForm();

    if(this.agentCheck)
    {
      this.memoryService.getUrlHistory().subscribe((res)=>
      {
        this.previousUrl =  res;
        if(this.previousUrl.length > 0)
        {
          this.currentUrl =  this.router.url;
          this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else
    {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if(!this.previousUrl){
        this.currentUrl =  this.router.url;
        this.previousUrltemp= this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }

  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
  getProjectDetails()
  {
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');

        this.project.getProjectById(this.projectId).subscribe((
          data => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);
            //console.log(this.projectData);
            this.getTestData();
            // this.projectName = this.projectData.projectName
          }
        ))
      }
    )
  }

  refreshPage() {
    this.document.defaultView.location.reload();
  }
  getTestData(loadSelectedData = false) {
    this.dataService.getManageTestData(this.projectId).subscribe(
      (data) => {
        if (data) {
          this.testData = data['textData'];
          this.route.queryParams.subscribe((data)=>
          {
            //console.log(data)
            if(data.testId)
            {
             
              this.testCaseId = data.testCaseId;
              this.testId = data.testId;
              this.testDataSourceName = data.testDataSourceName;
              this.settingNameForHightLight = data.settingName;
              let selectedItem
              if(this.testData)
              {
                selectedItem = this.testData.filter((f) => f.name === this.testDataSourceName && f.settingName ==this.settingNameForHightLight);
                if(selectedItem[0]){
                  this.scriptDataById =  JSON.parse(JSON.stringify(selectedItem));
                  this.updateScript(this.scriptDataById[0]);
                  this.updateForm = true;
                  this.showBackButton = true;
                }
               else{
                this.toastrService.clear();
                this.toastrService.warning('Associated Data is Deleted , So Kindly Associate New')
               }
              }
    
              //console.log(this.scriptDataById);
              
               setTimeout(()=>
               {
                  this.testDataSourceName = '';
               },10000)
            }
            else
            {
                //console.log("inside else");
                if(loadSelectedData)
                {
                    this.updateScript(this.scriptDataById[0]);
                }
                return;
            }

           
          })
        }
        // this.refreshPage();


      });
  }
  // name: "hello"
  // projectId: "61276c94a1f486a24017af5e"
  // runType: "SEQUENTIAL"
  // settingName: "default"
  // text: "this is for dev perpose"
  loadForm() {
    this.testDataForm = this.formBuilder.group({
      name: ['', Validators.required],
      settingName: ['default',Validators.required],
      runType: ['SEQUENTIAL',Validators.required],
      text: []
    })
    this.loadHeaderForm();
  }

  loadHeaderForm()
  {
    this.addHeaderForm = this.formBuilder.group({
      headerName: [ "", Validators.required],
    });
  }
  get f() { return this.testDataForm.controls; }

  ontestData() {
   //console.log(this.selectedMatIndex);
    this.submitted = true;
    if (this.testDataForm.invalid) {
      return;
    }
    var objFormval = this.testDataForm.value;
    if (this.updateForm === true) {
      let  ValueForUpdate;
      let emptyHeaderCheck = false;
      this.gridTableHeader.forEach((element)=>
      {
        if(element == "")
        {
            emptyHeaderCheck = true;
        }
      })
      if(emptyHeaderCheck)
      {
        //console.log("inside if")
        this.toastrService.warning("All Column Header must not be Blank");
        return;
      }

      if(this.selectedMatIndex == 0)
      {
         ValueForUpdate = {
          id: this.scriptDataById[0].id,
          name: objFormval.name,
          settingName: objFormval.settingName,
          runType: objFormval.runType,
          text: objFormval.text,
          projectId: this.projectId,
        }
      }
      else{
        let textData = this.editTestData(this.gridTableHeader);
        ValueForUpdate = {
          id: this.scriptDataById[0].id,
          name: objFormval.name,
          settingName: objFormval.settingName,
          runType: objFormval.runType,
          text: textData,
          projectId: this.projectId,
        }

      }

      if(!emptyHeaderCheck)
      {
        this.http.put(this.url + '/HuLoopRest/huloop/textData', ValueForUpdate).subscribe((data) => {
          this.getTestData(true);
          // this.refreshTestData(data);
          this.enableTableEdit = false;
         // this.testDataForm.reset();
          this.toastrService.success('Test data Updated Successfully');
          
          
        });
      }
      

    }
    if (this.updateForm === false) {
      const ValueForAdd = {
        name: objFormval.name,
        settingName: objFormval.settingName,
        runType: objFormval.runType,
        text: objFormval.text,
        projectId: this.projectId,
        //  parentTestDataId: this.parentTestDataId
      }


      this.http.post(this.url + '/HuLoopRest/huloop/textData', ValueForAdd).subscribe((data) => {
        if (data) {
          this.testData = data;
          this.getTestData(true);
          this.testDataForm.reset();
          this.toastrService.clear();
          this.toastrService.success('Test data saved successfully');
        }
      });

    }

  }

  updateScript(testdata) {
    this.default = testdata.settingName;
    this.Sequential = testdata.runType;
    this.gridTableHeader= [];
    this.gridTableBody = [];
    this.enableTableEdit = false;
    // this.updateForm = false;

    let selectedItem  = this.testData.filter((f) => f.id === testdata.id);
    this.scriptDataById =  JSON.parse(JSON.stringify(selectedItem));

    //console.log(this.scriptDataById, testdata);
    this.updateGridView(this.scriptDataById[0]);
  }

  ClearForm() {
    this.updateForm = false;
    this.default = "default";
    this.Sequential = "SEQUENTIAL";
    this.loadForm();
    return;
  }

  delRow(id, name, settingName) {
    this.confirmationDialogService.openConfirmDialog('Do you want to delete ' + name +  '?')
      .afterClosed().subscribe(res => {
        if (res) {
          this.dataService.deleteTestData(this.projectId, id, name, settingName).subscribe(
            (data) => {
              this.getTestData();
              this.toastrService.clear();
              this.toastrService.success('  Test Data Deleted successfully');
              this.ClearForm();
            }
          );
        }
      });
  }

  resetTestDataModel() {
    this.testDataFileName = "";
    this.testDataFile = undefined;
  }


  uploadTestData(event: any) {
    this.testDataFile = event.target.files[0];
    this.testDataFileName = this.testDataFile.name.substring(0, this.testDataFile.name.lastIndexOf('.'));
  }

  manageTestData(testData) {
    //console.log(testData);
    this.selectedTestDataId = testData.id;
    this.selectedTestDataName = testData.name;
  }

  onImportTestData() {
    if (this.testDataFile == undefined) {
      return;
    }
    //console.log("inside upload");
    var fd = new FormData();
    fd.append('file', this.testDataFile);

    this.http.post(this.url + '/HuLoopRest/huloop/textData/upload/' + this.projectId + '/default/' + this.selectedTestDataId + '/' + this.selectedTestDataName, fd).subscribe((res) => {
      this.toastrService.success("Test data uploaded successfully");
      this.cancelImportTestDataScreen.nativeElement.click();
      this.getTestData()
    });
    // this.projectService.importTestData(this.testDataFile, this.projectId, testDataId, testDataName).subscribe((res)=>
    // {
    //   //console.log(res);
    // })

  }

  downloadTestData(selectedTestData) {
    if(selectedTestData.text){
      if(!selectedTestData.text.trim()){
        this.toastrService.clear();
        this.toastrService.warning('Do not have any data to download');
        return; 
      }
    }
   if(!selectedTestData.text){
     this.toastrService.clear();
     this.toastrService.warning('Do not have any data to download');
     return;
   }
    var testData = selectedTestData.text.split(/\n(?=(?:(?:[^']*'){2})*[^']*$)/);
    var header = [];
    var csvData = [];
    var fileName = selectedTestData.name;

    for (var i = 0; i < testData.length; i++) {
      if (testData[i].indexOf("=") > -1) {
        var data = testData[i].split("=");
        header.push(data[0]);
        var values = data[1].split(/,(?=(?:(?:[^']*'){2})*[^']*$)(?=(?:(?:[^"]*"){2})*[^"]*$)/);
        for (var j = 0; j < values.length; j++) {
          if (!csvData[j]) {
            var cData = new Object();
            if (i > 0) {
              for (var t = 0; t < i; t++) {
                var headerKey = header[t];
                cData[headerKey] = '';
              }
            }
            csvData.push(cData);
          }
          var dataKey = data[0];
          var jsonObject = csvData[j];
          var origVal;
          origVal = "";

          if (values[j].startsWith("'")) {
            origVal = values[j].trim();
            origVal = origVal.replace(new RegExp("'", "gi"), '');
          } else if (values[j].startsWith("\"")) {
            origVal = values[j].trim();
            origVal = values[j].substring(1, origVal.length - 1);
            origVal = origVal.replace(/""/g, '"');
          } else

            var origVal = values[j];

          jsonObject[dataKey] = origVal;
        }
      }
    }
    //console.log(csvData, header);
    this.excelService.exportAsExcelFile(csvData, fileName);
  }

  updateGridView(selectedTestData)
  {
    if(!selectedTestData.text)
    {
      //console.log(selectedTestData);
      let header = [""];
      let body = [""];
      this.emptyGridTableHeader = header;
      this.emptyGridTableBody[0] = body;
      return;
    }
    var testData = selectedTestData.text.split(/\n(?=(?:(?:[^']*'){2})*[^']*$)/);
    var header = [];
    var csvData = [];
    var fileName = selectedTestData.name;

    for (var i = 0; i < testData.length; i++) {
      if (testData[i].indexOf("=") > -1) {
        var data = testData[i].split("=");
        header.push(data[0]);
        var values = data[1].split(/,(?=(?:(?:[^']*'){2})*[^']*$)(?=(?:(?:[^"]*"){2})*[^"]*$)/);
        csvData.push(values);
        // for (var j = 0; j < values.length; j++) {
        //   if (!csvData[j]) {
        //     var cData = new Object();
        //     if (i > 0) {
        //       for (var t = 0; t < i; t++) {
        //         var headerKey = header[t];
        //         cData[headerKey] = '';
        //       }
        //     }
        //     csvData.push(cData);
        //   }
        //   var dataKey = data[0];
        //   var jsonObject = csvData[j];
        //   var origVal;
        //   origVal = "";

        //   if (values[j].startsWith("'")) {
        //     origVal = values[j].trim();
        //     origVal = origVal.replace(new RegExp("'", "gi"), '');
        //   } else if (values[j].startsWith("\"")) {
        //     origVal = values[j].trim();
        //     origVal = values[j].substring(1, origVal.length - 1);
        //     origVal = origVal.replace(/""/g, '"');
        //   } else

        //     var origVal = values[j];

        //   jsonObject[dataKey] = origVal;
        // }
      }
    }

    this.gridTableHeader = header;
    if(csvData.length == 0)
    {
      this.gridTableBody = [];
    }
    else
    {
      this.gridTableBody = this.transpose(csvData);
    }
    
    //console.log(this.gridTableHeader);
    //console.log(this.gridTableBody)

   
  }

  transpose(matrix)
  {
    //console.log(matrix);
    let [row] = matrix
    return row.map((value, column) => matrix.map(row => row[column]))
  }

  redirectToTestCases()
  {
    this.router.navigate(['/TestSuit/'+ this.projectId + "/" + this.testId],
    {
      queryParams : 
      {
        testCaseId : this.testCaseId
      }
    })
  }

  addHeader()
  {
    console.log(this.addHeaderForm.value);

    this.gridTableHeader.push(this.addHeaderForm.value.headerName);
    this.gridTableBody.forEach((element)=>
    {
      element.push("");
    });
    this.updateTextData();
  }

  updateHeader()
  {
      
      if(this.selectedHeader == '')
      {
          this.showHeaderFormMsg =  true;
          return;
      }
      else{
        this.showHeaderFormMsg = false;
      }

      if(this.gridTableHeader[this.selectedHeaderIndex] == this.selectedHeader)
      {
          this.toastrService.info("change the header value and try again");
          return;
      }

      this.updateTextData();

  }

  updateTextData()
  {
    var header = [...this.gridTableHeader];
    //console.log(header, this.selectedHeaderIndex)
    header[this.selectedHeaderIndex] = this.selectedHeader;
   
    var testData  =  this.editTestData(header);
    if(!testData)
    {
      return;
    }
    var objFormval = this.testDataForm.value;

      let obj = {
        id: this.scriptDataById[0].id,
        name: objFormval.name,
        settingName: objFormval.settingName,
        runType: objFormval.runType,
        text: testData,
        projectId: this.projectId,
      }
      this.http.put(this.url + '/HuLoopRest/huloop/textData', obj).subscribe((data) => {
        this.toastrService.success('Test Data Updated Successfully');
        this.cancelHeaderUpdateModel.nativeElement.click();
        this.cancelAddHeaderModel.nativeElement.click();
        this.gridTableHeader = header;
        this.refreshTestData(data);
      });
  }
  
  updateBody(i,j)
  {
   
    this.gridTableBody[i][j] = this.selectedGridValue;
    //console.log(this.gridTableBody, this.selectedRow, this.selectedIndex);
  }

  editTestData(header) {
       var gridItems = this.gridTableBody;
       //console.log(header, gridItems);

            //convert grid data to String .
            var textData = '';
            if (header) {
                for (var i = 0; i < header.length; i++) {
                  //console.log(header[i].trim().length, header[i].trim().length !== 0);
                    if (header[i].trim().length !== 0) {
                        if (i !== 0) {
                            textData = textData + '\n';
                        }
                        textData = textData + header[i] + "=";
                        //console.log(textData);
                        for (var j = 0; j < gridItems.length; j++) {
                            var data =gridItems[j][i];
                            if (data && data.indexOf("'") > -1) {
                                this.toastrService.warning("Test data value cannot contain ' ");
                                return;
                            }
                            if (data && (data.indexOf(",") > -1 || data.indexOf("\n") > -1)) {
                                textData = textData + "'" + data + "'";
                            } else {
                                if (!data || data === null) {
                                    data = '';
                                }
                                textData = textData + data;
                            }
                            textData = textData + ",";

                        }
                        if(textData.includes(","))
                        {
                          textData = textData.substr(0, textData.length - 1);//removet the last comma from the String.
                        }
                    } else {
                        this.toastrService.clear();
                        this.toastrService.warning("All Column Header must not be Blank");
                        //loadTestData();
                        return null;
                    }
                }
            }
          return textData;
}

onUpdateTable(row,i,j)
{
    //console.log(row,i,j);
    this.selectedRow = i
    this.selectedIndex = j
    this.enableTableEdit = true;
    this.selectedGridValue = this.gridTableBody[i][j];
    //console.log(this.selectedGridValue);
}

refreshTestData(selectedData)
{
  this.dataService.getManageTestData(this.projectId).subscribe(
    (data) => {
      if (data) {
        this.testData = data['textData'];
        this.updateScript(selectedData);
      }
    });
}

onHeaderMenu(event: MouseEvent,index, type: string) {

  event.preventDefault();
  this.contextMenuPosition.x = event.clientX + 'px';
  this.contextMenuPosition.y = event.clientY + 'px';
  this.contextMenu.menuData = { 'index': index, 'type': type };
  this.contextMenu.menu.focusFirstItem('mouse');
  this.contextMenu.openMenu();

}

deleteColumn(index)
{
    this.gridTableHeader.splice(index,1);
    this.gridTableBody.forEach(element => {
        element.splice(index,1);
    });
}

// AddColumnToRight()
// {
//     this.gridTableHeader.push("");
//     this.gridTableBody.forEach((element)=>
//     {
//       element.push("");
//     })
// }

deleteRow(index)
{
    //console.log(this.gridTableBody, index);
    this.gridTableBody.splice(index,1);
}

InsertRowBelow(index)
{
  let length = this.gridTableBody[0].length - 1;
  //console.log(this.gridTableBody[0],length);

  let arrayList = [];

  for(let i=0; i<= length; i++)
  {
     arrayList.push("") 
  }
  this.gridTableBody.splice(index + 1, 0, arrayList);
}

InsertRowAbove(index)
{
  let length = this.gridTableBody[0].length - 1;
  //console.log(this.gridTableBody[0],length);

  let arrayList = [];

  for(let i=0; i<= length; i++)
  {
     arrayList.push("") 
  }
  this.gridTableBody.splice(index, 0, arrayList);

}

onTabChange(event)
{
  this.enableTableEdit =  false;
}
ngAfterViewInit(){
  this.getTestData(false);
}
}
